<template>
  <ul class="rating-list">
      <li v-for="(list, index) in lists" :key="index" class="selective-list">
          <p class="label">{{lang[list.lang]}}</p>
          <Star :max="max" :rating="list" @ratings="checkRatings"/>
      </li>
  </ul>
</template>

<script>
import Star from './module/Star'
export default {
    name: 'RatingList',
    props: {
        lang: {},
        max: {
            type: Number,
            default: 5
        },
        lists: {
            type: Array,
            default: ()=>{
                return  [
                    {id: '', label: '위치', lang: '', value: 0},
                    {id: '', label: '서비스', lang: '', value: 1},
                    {id: '', label: '청결도', lang: '', value: 2},
                    {id: '', label: '시설', lang: '', value: 3},
                ]
            }
        },
        
    },
    components: {
        Star
    },
    methods: {
        checkRatings(payload){
            this.$emit('ratings', payload);
        }
    }
}
</script>

<style lang="scss" scoped>
.rating-list{
    margin: 24px 0;
    padding: 24px 0;
    border-top: 1px solid $color-border;
    border-bottom: 1px solid $color-border;

    .selective-list{
        align-items: center;
    }
}


</style>